import script from "./UserGroupDropdownContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserGroupDropdownContent.vue?vue&type=script&setup=true&lang=ts"

import "./UserGroupDropdownContent.vue?vue&type=style&index=0&id=1a0c99b7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0c99b7"]])

export default __exports__